{
  "agent_name": "{{brand}} 管理程序",
  "crumbs": "当前位置",
  "common": {
    "cancel": "取消",
    "details": "详细",
    "loading": "读取中",
    "retry": "重试",
    "saving": "保存中…"
  },
  "nav": {
    "group": "IT 监控",
    "incidents": "事故",
    "unhandled_n": "{{n}} 件事故还没有人处理",
    "hosts": "主机",
    "network": "网络与应用",
    "remote": "远端协助"
  },
  "sev": {
    "P1": "紧急",
    "P2": "重要",
    "P3": "一般"
  },
  "home": {
    "bad": "异常",
    "attention": "注意",
    "ok": "正常",
    "unreadable": "读不到",
    "unset": "未设置",
    "maintenance": "维护中",
    "maintenance_until": "维护中 · 到 {{time}}",
    "off_hours": "营业时段外",
    "baselining": "建立基准中（不影响状态）"
  },
  "now": {
    "ongoing_for": "进行中 · {{n}} 分钟",
    "recovered_at": "已恢复 {{time}}"
  },
  "handling": {
    "open": "未处理",
    "open_recovered": "未处理（还没人看）",
    "acknowledged_by": "{{name}}已看到",
    "claimed_by": "{{name}}处理中",
    "mine": "你处理中",
    "since": " · {{time}} 起",
    "resolved": "已结案"
  },
  "person": {
    "you": "你",
    "someone": "有人",
    "system": "系统"
  },
  "impact": {
    "not_recording": "{{n}} 个摄像头没有录像 · 已 {{min}} 分钟",
    "gap": "缺录 {{n}} 个 × {{min}} 分钟（无法补回）",
    "fine": "录像不受影响",
    "fine_note": "录像不受影响：{{note}}",
    "unknown": "录像状态读不到",
    "unknown_note": "录像状态读不到：{{note}}"
  },
  "incident": {
    "affected_n": "影响 {{n}} 台",
    "recurring": "反复发生 · {{n}} 次",
    "for_min": "已 {{n}} 分钟",
    "silenced_until": "静默到 {{time}} · {{name}}",
    "alarms_open": "同$t(translation:leaf.cur)有警报 {{n}}",
    "impact": "影响",
    "see_gap": "看缺录前后",
    "alarm_xref": "同$t(translation:leaf.cur)有 {{n}} 条还没处理的警报",
    "see_alarms": "看警报",
    "affected_title": "受影响设备（{{n}}）",
    "affected_all": "全部 {{n}} 台",
    "col_kind": "种类",
    "col_name": "名称",
    "col_state": "状态",
    "timeline": "时间轴",
    "people": "这件事的人",
    "handler": "处理人",
    "seen_by": "看过",
    "resolved_by": "结案",
    "escalation": "升级",
    "nobody": "还没有",
    "not_found": "这个事故找不到了",
    "not_found_body": "可能超过保存期限（13 个月），或你已经没有这个$t(translation:leaf.cur)的权限。",
    "not_found_crumb": "找不到",
    "back_list": "回事故列表",
    "unavailable": "读不到这个事故",
    "abar": "事故操作",
    "notified": "已通知"
  },
  "target": {
    "camera": "摄像头",
    "recorder": "录像主机",
    "host": "主机",
    "network_device": "网络设备",
    "probe": "应用探针",
    "kinio_device": "设备"
  },
  "target_state": {
    "not_recording": "没有录像",
    "offline": "离线",
    "unreadable": "读不到",
    "recovered": "已恢复",
    "ok": "正常",
    "service_stopped": "服务停了",
    "on_battery": "电池供电中"
  },
  "ev": {
    "system": "系统",
    "bad": "异常",
    "person": "人的操作",
    "recover": "恢复",
    "notify": "通知"
  },
  "ev_person": {
    "open": "{{name}}：重新打开",
    "acknowledged": "{{name}}：已看到",
    "claimed": "{{name}}：我来处理",
    "resolved": "{{name}}：结案",
    "assigned": "{{name}}：交给 {{to}}"
  },
  "act": {
    "claim": "我来处理",
    "take_over": "换我处理",
    "acknowledge": "已看到",
    "resolve": "标成已解决…",
    "close": "结案…"
  },
  "resolve": {
    "title": "结案这件事故",
    "body": "结案后不再升级与提醒；30 分钟内同一原因再发生会回到这件事故。",
    "note": "处理说明（选填）",
    "ok": "结案"
  },
  "conflict": {
    "handled_by": "已由 {{name}} 处理，画面已更新",
    "changed": "这件事故的状态刚被别人改了，画面已更新",
    "next": "你按的操作没有送出。要接手请按〔换我处理〕。"
  },
  "filter": {
    "all": "全部",
    "unclaimed": "没人认领",
    "mine": "我处理的",
    "org": "组织",
    "org_label": "组织：{{label}}",
    "org_all": "全部组织",
    "org_n": "{{n}} 个组织",
    "org_unnamed": "客户组织",
    "org_clear": "清除组织筛选",
    "org_max": "最多选 {{n}} 个组织"
  },
  "overview": {
    "it_blocks": "IT 监控",
    "incidents_title": "现在要处理的事故",
    "sev_n_P1": "紧急 {{n}}",
    "sev_n_P2": "重要 {{n}}",
    "sev_n_P3": "一般 {{n}}",
    "filter": "筛选事故",
    "see_all": "看全部 {{n}} 件",
    "none_watching": "目前没有要处理的事 · 看管中 {{homes}} 个$t(translation:leaf.cur)",
    "none_filtered": "没有符合的事故",
    "incidents_unavailable": "读不到事故列表；其他区块照常。",
    "homes_title": "$t(translation:leaf.cur)状态",
    "homes_n": "{{n}} 个$t(translation:leaf.cur)",
    "homes_counts": "各状态的$t(translation:leaf.cur)数",
    "homes_unavailable": "读不到$t(translation:leaf.cur)状态；其他区块照常。",
    "others_ok": "其余 {{n}} 个正常",
    "homes_more": "另有 {{n}} 个，到事故列表看全部",
    "none_watching_hosts": "目前没有要处理的事 · 看管中 {{homes}} 个$t(translation:leaf.cur)、{{hosts}} 台电脑",
    "orgs_homes_n": "{{orgs}} 个组织 · {{n}} 个$t(translation:leaf.cur)",
    "org_p1_unclaimed": "没人认领的紧急 {{n}}",
    "org_bad_homes": "异常 {{n}} 个$t(translation:leaf.cur)",
    "org_unreadable_homes": "读不到 {{n}} 个$t(translation:leaf.cur)",
    "org_open": "未结事故 {{n}}",
    "org_hosts_offline": "离线主机 {{n}}",
    "orgs_others_ok": "其余 {{n}} 个组织正常",
    "orgs_more": "另有 {{n}} 个组织，到事故清单看全部"
  },
  "live": {
    "on_s": "实时 · {{n}} 秒前更新",
    "on_m": "实时 · {{n}} 分钟前更新",
    "off": "已中断 · 最后更新 {{time}}",
    "stale_bar": "更新中断 {{n}} 分钟：下面是 {{time}} 的状态，可能已经有新事故。",
    "reconnect": "重新连接"
  },
  "incidents": {
    "tabs": "事故分页",
    "tab_open": "未结",
    "tab_open_n": "未结（{{n}}）",
    "tab_all": "全部",
    "none_open": "目前没有未结的事故",
    "none": "还没有事故",
    "none_filtered": "没有符合的事故",
    "clear_filter": "清除筛选",
    "see_all": "看全部事故",
    "load_more": "再加载",
    "shown_all": "已显示全部 {{n}} 件",
    "unavailable": "读不到事故列表"
  },
  "enable_card": {
    "title": "用 {{console}} 看管 {{org}} 的网络与电脑",
    "body": "交换机断线、服务器停了、硬盘快坏，会先告诉你是哪个$t(translation:leaf.cur)、录像有没有受影响、可能原因与建议。只显示要处理的事，不会一直响。",
    "note": "电脑上要装「{{agent}}」，只回报健康信息，不看画面、文件与输入。启用要由 {{org}} 的负责人接受数据处理协议。",
    "start": "开始",
    "later": "之后再说"
  },
  "org": {
    "title": "IT 监控",
    "crumb_org": "组织设置",
    "enable_title": "启用 IT 监控",
    "enable_crumb": "启用",
    "tabs": "IT 监控分页",
    "tab_status": "启用",
    "tab_oncall": "值班表",
    "tab_keys": "管理员 passkey",
    "no_admin": "只有组织所有者或组织管理员能设置 IT 监控。",
    "dpa": "数据处理协议",
    "dpa_accepted": "已接受 {{v}} 版（{{time}}）",
    "dpa_none": "还没接受",
    "homes": "看管的$t(translation:leaf.cur)",
    "homes_none": "还没有",
    "home_settings": "监控设置",
    "start_wizard": "开始启用",
    "open_wizard": "加$t(translation:leaf.cur)或建部署令牌",
    "manage": "设置",
    "card_enabled": "看管中 {{n}} 个$t(translation:leaf.cur) · 值班表与启用在这里设置",
    "card_none": "还没启用。用它看管$t(translation:leaf.cur)的网络与电脑。",
    "tab_templates": "监控模板",
    "tab_handover": "接手",
    "tab_built": "代建的客户"
  },
  "keys": {
    "intro": "每台电脑的管理程序只认这份清单上的签名用 passkey 签的安全策略。新增要清单上的一把在签名页确认；移除不用签，但组织之前建的部署令牌会全部失效。",
    "unavailable": "读不到管理员清单（{{detail}}）。",
    "current": "目前清单（第 {{v}} 版）",
    "empty": "清单是空的：还没有人能签安全策略。加入的第一把不用签，之后建的部署令牌才带新清单。",
    "you": "你",
    "stale": "账号或 passkey 已经不在，请移除",
    "remove_replaced": "移除（换了设备）",
    "remove_lost": "移除（遗失或被盗）",
    "confirm_title": "移除 {{who}} 的 passkey {{id}}",
    "confirm_tokens": "移除后，组织之前建的 {{n}} 个部署令牌会失效（已报到的电脑不受影响）：",
    "confirm_no_tokens": "没有会失效的部署令牌。",
    "token_line": "{{name}} · 还有 {{n}} 台没报到",
    "confirm_remove": "立即移除（{{n}} 个令牌会失效）",
    "candidates": "可以加入的签名用 passkey",
    "no_candidates": "没有。组织所有者或管理员在启用向导 ⓪ 创建签名用 passkey 之后会出现在这里。",
    "add_anchor": "加入",
    "add_sign": "加入（用我的 passkey 签）",
    "need_listed": "要清单上已有的管理员替你加入；你自己的签名用 passkey 还不在清单上。",
    "reinstall_title": "{{n}} 台电脑的管理员清单无法更新",
    "reinstall_body": "清单曾被清空后重新设置，这些电脑按安全规则不接受新的清单，远程协助与需要签名的自动处置会被拒。用新的部署令牌在这些电脑重新安装管理程序（新令牌带当前的清单），重装后旧的那条会被取代。",
    "reinstall_reanchor": "电脑上是 v{{v}} 的清单，之后经过重新设置",
    "reinstall_rejected": "电脑拒收新清单（{{code}}）",
    "reinstall_token": "建新的部署令牌",
    "reinstall_token_home": "建新的部署令牌 · {{home}}"
  },
  "wizard": {
    "steps": "启用步骤",
    "done_sr": "（已完成）",
    "step_0": "passkey",
    "step_1": "数据处理协议",
    "step_2": "选$t(translation:leaf.cur)",
    "step_5": "部署令牌",
    "title_0": "先确认你有 passkey",
    "title_1": "IT 监控数据处理协议",
    "title_2": "选要看管的$t(translation:leaf.cur)",
    "title_5": "建立部署令牌",
    "next_0": "下一步：数据处理协议",
    "next_1": "下一步：选$t(translation:leaf.cur)",
    "next_5": "完成",
    "prev": "上一步",
    "skip": "跳过这一步",
    "save_leave": "保存并离开",
    "skip_finish": "跳过，之后再建",
    "finish": "完成，回 IT 监控",
    "progress": "设置进度 {{n}} / {{total}}",
    "progress_note": "每一步都可以先跳过，之后在「组织设置 › IT 监控」接着做。",
    "denied": "只有组织所有者或组织管理员能启用",
    "denied_body": "请 {{org}} 的所有者或组织管理员启用。",
    "status_unavailable": "读不到 IT 监控的状态（{{detail}}）。",
    "passkey_ok": "你已经有 {{n}} 个签名用 passkey。",
    "passkey_need": "改电脑的管理员清单、签安全策略都要用签名用 passkey（在独立的签名页创建，与登录用的 passkey 分开；验证码不算）。",
    "passkey_readonly": "还没注册 passkey 前，IT 监控的安全设置对你是只读的。",
    "passkey_add": "创建签名用 passkey",
    "passkey_no_sign": "这个环境还没开签名页，暂时不能创建签名用 passkey。",
    "passkey_sign_note": "会打开一个新窗口（签名页），在那里确认。",
    "passkey_name": "IT 监控",
    "passkey_unsupported": "这个浏览器不支持 passkey；请换一个浏览器或在手机上注册。",
    "passkey_err": "没有注册成功（{{code}}）。",
    "dpa_version": "版本 {{v}}",
    "dpa_summary": "摘要",
    "dpa_s1": "{{org}} 是数据的控制者；服务供应商是受托者。",
    "dpa_s2": "收集电脑与网络设备的健康信息（CPU、内存、磁盘、服务是否在运行、流量总量），不收画面、文件内容、按键内容。",
    "dpa_s3": "保存：指标 24 个月（汇总）、事故 13 个月、审计至少 1 年；终止后 30 天删除。",
    "dpa_full": "看全文",
    "dpa_accept": "我代表 {{org}} 接受 IT 监控数据处理协议（{{v}} 版）",
    "dpa_accepted": "已接受 {{v}} 版（{{time}}）。",
    "dpa_updated": "协议刚更新为 {{v}} 版，请重新看过再接受。",
    "before_dpa": "没接受前能做什么",
    "before_dpa_body": "可以先选$t(translation:leaf.cur)、建部署令牌、把「{{agent}}」装到电脑；电脑会等协议接受后才开始回报，不用重装。",
    "need_dpa": "要先接受数据处理协议才能启用$t(translation:leaf.cur)。",
    "to_dpa": "去接受协议",
    "homes_intro": "选了的$t(translation:leaf.cur)开始看管；开了 IT 监控的$t(translation:leaf.cur)，设备断线、录像中断改由事故通知（同一件事只通知一次）。",
    "homes_none": "这个组织还没有$t(translation:leaf.cur)。",
    "home_enabled": "已启用",
    "enable": "启用 {{n}} 个$t(translation:leaf.cur)",
    "need_homes": "要先启用至少一个$t(translation:leaf.cur)才能建部署令牌。",
    "to_homes": "去选$t(translation:leaf.cur)",
    "token_side": "建立令牌要再确认一次身份；令牌只会显示一次。"
  },
  "token": {
    "name": "名称",
    "home": "报到到哪个$t(translation:leaf.cur)",
    "default_name": "{{home}} 第一批",
    "expiry": "有效期限",
    "days": "{{n}} 天（到 {{until}}）",
    "expiry_hint": "最长 30 天。过期后还没装的电脑要用新令牌。",
    "max": "最多几台（必填）",
    "max_hint": "超过授权台数的电脑会先是未授权，买了之后依报到顺序转正。",
    "max_bad": "请填 1 到 10000 的整数。",
    "cidrs": "只允许从这些网络报到（选填）",
    "cidrs_hint": "在别的网络装的电脑会被挡下，回到公司网络后自动重试。",
    "cidrs_bad": "这些不是网段：{{list}}",
    "ownership": "这批电脑归谁",
    "own_org": "组织拥有",
    "own_byod": "员工自有",
    "ownership_hint": "之后在主机页可以逐台改。",
    "expected": "预期清单（选填）",
    "expected_hint": "导入 CSV 或 AD 导出的电脑名称；报到进度会列出还没报到的电脑。",
    "expected_n": "已读到 {{n}} 台电脑名称。",
    "once_note": "建立前会再确认一次身份；令牌只会显示一次。",
    "create": "确认身份并建立",
    "new": "建立部署令牌…",
    "new_title": "建立部署令牌",
    "once_title": "只会显示这一次",
    "once_body": "离开这一页就看不到了。请复制到安装设置里，或下载成文件。",
    "copy": "复制令牌",
    "copied": "已复制",
    "download": "下载令牌文件",
    "once_meta": "{{name}} · {{home}} · 最多 {{n}} 台 · 到 {{until}}",
    "install_title": "安装「{{agent}}」",
    "install_1": "在要看管的电脑安装「{{agent}}」。",
    "install_2": "把令牌文件放到那台电脑（只给系统管理员读），安装时指定这个文件；令牌不要写在命令行。",
    "install_3": "装好后「{{agent}}」会自动报到；在那台电脑打开「{{agent}}」可以看收了什么。",
    "install_note": "令牌不要放在大家都读得到的共享文件夹：等于把令牌交给所有看得到的人。",
    "after_title": "装好之后",
    "after_body": "到报到进度实时看每台的状态与失败原因。",
    "see_progress": "看报到进度",
    "state_active": "有效",
    "state_expired": "已过期",
    "state_exhausted": "已用完",
    "state_revoked": "已失效",
    "col_state": "状态",
    "col_progress": "报到",
    "col_expires": "到期",
    "progress_short": "已报到 {{a}} / {{n}} · 失败 {{f}}",
    "list_unavailable": "读不到部署令牌",
    "none": "还没有部署令牌",
    "none_body": "建一个令牌，在电脑安装时带上它，电脑就会报到到这个$t(translation:leaf.cur)。",
    "unavailable": "读不到这个令牌",
    "revoke_btn": "撤销…",
    "revoke_title": "撤销「{{name}}」",
    "revoke_body": "撤销后还没报到的 {{n}} 台会报到失败；已经报到的电脑不受影响。",
    "revoke": "撤销令牌",
    "revoked_manual": "这个令牌已手动撤销（{{time}}）；还没报到的电脑要改用新令牌。",
    "revoked_admin_removed": "这个令牌已失效（{{time}}）：管理员清单有人被移除。请建新的令牌，换掉安装设置里的旧令牌。",
    "revoked_creator_left": "这个令牌已失效（{{time}}）：建立者已离开组织。请建新的令牌，换掉安装设置里的旧令牌。",
    "revoked_rebuilt": "这个令牌已被新的取代（{{time}}）。",
    "expired_bar": "这个令牌已在 {{time}} 过期；还没装的电脑要用新令牌。",
    "kpi_approved": "已报到",
    "kpi_failed": "失败",
    "kpi_remaining": "还没报到",
    "kpi_remaining_note": "没送出报到的电脑云端看不到",
    "failed_title": "失败（{{n}}）",
    "col_host": "电脑",
    "col_reason": "原因与你能做什么",
    "col_os": "操作系统",
    "col_ip": "来源 IP",
    "col_time": "时间",
    "failed": "失败",
    "notyet_title": "还没报到（{{n}}）",
    "notyet_expected": "对照预期清单还没报到：{{list}}{{more}}",
    "and_more": " 等 {{n}} 台",
    "notyet_hint": "超过 1 小时没消息的电脑可能没装成功（安装设置还没套用、电脑没开、被杀毒软件挡下）；原因只在那台电脑上看得到。",
    "ok_title": "已报到（{{n}}）",
    "ok_none": "还没有电脑报到。",
    "unexpected": "不在预期清单",
    "kpi_pending": "等你确认",
    "rebuild_btn": "重建…",
    "rebuild_title": "重建“{{name}}”",
    "rebuild": "确认身份并重建",
    "rebuild_body": "沿用原来的$t(translation:leaf.cur)、来源网络、归属与预期清单，绑定目前的管理员清单；台数上限是还没报到的 {{n}} 台。新令牌只会显示一次，要换掉安装设置（GPO 脚本、Intune、RMM）里的旧令牌。换掉之前，还没报到的电脑会继续用旧令牌重试、照样失败，事故台数增加属正常；已经报到的电脑不受影响。",
    "rebuilt_note": "这是重建的新令牌：旧的那一个已经换掉。请把下面的安装参数换进 GPO 脚本、Intune 或 RMM。"
  },
  "enroll": {
    "todo_prefix": "你能做什么：",
    "reason_expired": "令牌已过期",
    "todo_expired": "建一个新令牌，换掉安装设置里的旧令牌。",
    "reason_exhausted": "已达台数上限",
    "todo_exhausted": "建一个新令牌，或请管理员提高上限。",
    "reason_revoked": "令牌已失效",
    "todo_revoked": "请建立者或代管的安装商建新的令牌，换掉安装设置里的旧令牌。",
    "reason_source": "来源网络不在允许范围",
    "todo_source": "回公司网络后会自动重试；或在令牌加允许的网段。",
    "reason_dpa": "还没接受数据处理协议",
    "todo_dpa": "接受协议后电脑每 15 分钟自动重试，不用重装。",
    "reason_clock": "电脑时间差太多",
    "todo_clock": "校正这台电脑的时间，校正后自动重试。",
    "reason_hw": "这台电脑的硬件识别对不上",
    "todo_hw": "可能是复制的系统镜像；请在那台电脑重新安装。",
    "reason_invalid": "令牌不对",
    "todo_invalid": "确认安装设置里的令牌是完整的一整串。",
    "reason_other": "报到失败",
    "todo_other": "看详细里的错误码，或在那台电脑打开管理程序看原因。",
    "reason_host_rejected": "已拒绝加入",
    "todo_host_rejected": "这台电脑之后用这把令牌报到都会被拒；确定要加入的话请重建令牌，再用新令牌重装。"
  },
  "home_settings": {
    "title": "监控设置",
    "crumb_sites": "组织与场所",
    "tabs": "监控设置分页",
    "tab_tokens": "部署令牌",
    "tab_notify": "通知",
    "tokens_intro": "电脑安装时带部署令牌，就会报到到这个$t(translation:leaf.cur)。",
    "not_found": "找不到这个$t(translation:leaf.cur)",
    "back_sites": "回组织与场所",
    "not_enabled": "这个$t(translation:leaf.cur)还没开 IT 监控；令牌可以先建，电脑要等启用后才开始回报。",
    "no_org": "这个$t(translation:leaf.cur)不属于组织，没有值班表。",
    "unavailable": "读不到监控设置",
    "tab_collectors": "收集器",
    "tab_thresholds": "门槛与等级",
    "tab_probes": "探针",
    "tab_windows": "维护与营业时段",
    "tab_site": "现场资讯"
  },
  "notify": {
    "schedule": "值班表",
    "no_schedule": "不用值班表",
    "no_schedule_hint": "没选值班表时，紧急事故送$t(translation:leaf.cur)所有者与管理员。",
    "schedule_hint": "紧急事故 0 分送目前时段的值班者；空档直接送值班主管。",
    "contact": "客户联系人",
    "contact_default": "默认：组织所有者 {{name}}",
    "contact_default_none": "默认：组织所有者",
    "contact_hint": "值班者与值班主管都收不到时，紧急事故送这个人。",
    "channels": "通知渠道：App 推送（紧急事故用时效性通知）与 Email；不提供短信与语音。",
    "save_note": "改通知设置要再确认一次身份，并会通知这个$t(translation:leaf.cur)所属组织的所有者与管理员。",
    "save": "保存",
    "saved": "已保存。",
    "edit_schedules": "编辑值班表"
  },
  "oncall": {
    "intro": "$t(translation:leaf.cur)指定值班表、不写人名；每周一 00:00（值班表时区）换下一位。",
    "new": "新增值班表",
    "none": "还没有值班表",
    "none_body": "没有值班表时，紧急事故送$t(translation:leaf.cur)所有者与管理员。",
    "unavailable": "读不到值班表",
    "name": "名称",
    "now_on": "现在值班",
    "nobody_now": "没有人值班 → 直接送 {{name}}",
    "supervisor": "值班主管",
    "supervisor_hint": "15 分钟没有人〔我来处理〕时送他；空档也直接送他。",
    "used_by": "用在",
    "homes_n": "{{n}} 个$t(translation:leaf.cur)",
    "edit_title": "编辑值班表",
    "not_found": "找不到这份值班表",
    "back": "回值班表",
    "tz": "时区",
    "rotation_start": "轮换起点",
    "rotation_start_hint": "这一天所在那周由名单第一位值班。",
    "slot_title": "时段与轮换",
    "slot_name": "时段名称",
    "slot_default": "全天",
    "time": "时间",
    "start": "开始",
    "end": "结束",
    "time_hint": "开始与结束一样 = 整天；结束早于开始 = 跨午夜。",
    "days": "星期",
    "gap": "其他时间没有人值班：紧急事故直接送值班主管 {{name}}（不叫醒客户）。",
    "rotation": "按周轮换名单",
    "rotation_empty": "还没有人。至少加一位。",
    "this_week": "本周",
    "next_week": "下周",
    "up": "把 {{name}} 往前移",
    "down": "把 {{name}} 往后移",
    "remove": "从名单移除 {{name}}",
    "remove_short": "移除",
    "add_person": "加入轮换的人",
    "add": "加入",
    "pick": "选一位成员",
    "summary": "本周{{slot}}：{{now}} · 主管 {{sup}} · 下周：{{next}}",
    "summary_empty": "名单是空的：这段的紧急事故会直接送值班主管。",
    "save_note": "保存要再确认一次身份；会通知指定这份值班表的$t(translation:leaf.cur)所属组织。",
    "save": "保存值班表",
    "err_name": "请填名称",
    "err_supervisor": "请选值班主管",
    "err_days": "至少选一天",
    "err_time": "时间格式要是 时:分",
    "err_rotation": "轮换名单至少要有一位",
    "err_conflict": "这份值班表刚被别人改过；请刷新后再改。"
  },
  "day": {
    "1": "周一",
    "2": "周二",
    "3": "周三",
    "4": "周四",
    "5": "周五",
    "6": "周六",
    "7": "周日"
  },
  "err": {
    "default": "发生错误（{{code}}）。",
    "NETWORK": "连不上服务，请检查网络后重试。",
    "NO_SESSION": "登录已过期，请重新登录。",
    "UNAUTHORIZED": "登录已过期，请重新登录。",
    "FORBIDDEN": "你没有这个操作的权限。",
    "NOT_FOUND": "找不到，可能已经被删除或你没有权限。",
    "UNAVAILABLE": "服务暂时无法使用，请稍后再试。",
    "RATE_LIMITED": "太多次了，请稍后再试。",
    "REAUTH_REQUIRED": "要先确认身份才能做这个操作。",
    "PASSKEY_REQUIRED": "这个操作要用 passkey 确认；请先在「我的账号 › 安全性」注册 passkey。",
    "KMGR_REGION_UNSUPPORTED": "这个组织所在的地区不提供 IT 监控。",
    "KMGR_DPA_REQUIRED": "要先接受 IT 监控数据处理协议。",
    "INVALID_ARGUMENT": "数据不对，请检查后重试。",
    "INVALID_TRANSITION": "这件事故目前的状态不能这样改。",
    "INCIDENT_STATE_CONFLICT": "这件事故的状态刚被别人改了。",
    "CONFLICT": "刚被别人改过，请刷新后再试。",
    "FEATURE_DISABLED": "这个环境还没开这个功能。",
    "KMGR_STOPPED": "IT 监控已被组织暂停。",
    "HANDOVER_INCOMPLETE": "代建的组织还没完成接手",
    "ORG_LIMIT": "组织数量已达上限"
  },
  "cause": {
    "service_stopped": "{{target}} 的 {{subject}} 停了",
    "host_offline": "{{target}} 离线",
    "other": "{{target}} 异常",
    "disk_full": "{{target}} 的 {{subject}} 磁盘快满了",
    "power_outage": "停电",
    "ups_output_off": "{{target}} 输出已断",
    "ups_overload": "{{target}} 负载过高",
    "ups_battery": "{{target}} 电池需要处理",
    "poe_budget": "{{target}} PoE 供电超过门槛",
    "poe_denied": "{{target}} PoE 拒绝供电"
  },
  "home_reason": {
    "incidents": "{{n}} 件进行中的事故",
    "unreadable_since": "电脑都没有响应 · 最后上报 {{time}}",
    "unreadable_never": "电脑还没有上报过",
    "unset": "还没有电脑报到",
    "watching": "看管 {{n}} 台电脑",
    "collector_offline": "收集器 {{name}} 离线 {{n}} 分钟",
    "snmp_auth": "网络设备 SNMP 验证失败",
    "maintenance_by": "{{name}}设的维护"
  },
  "ev_text": {
    "opened": "开事故：{{cause}}",
    "recurred": "同一原因再次发生，并回这件事故",
    "recovered": "已恢复",
    "auto_resolved": "已恢复 24 小时没人处理，系统结案",
    "notify_opened": "推送给 {{who}}",
    "notify_resolved": "恢复通知（不响铃）给 {{who}}",
    "home_admins": "$t(translation:leaf.cur)所有者与管理员"
  },
  "dur": {
    "minutes": "{{n}} 分钟",
    "hours": "{{n}} 小时",
    "days": "{{n}} 天"
  },
  "global_stop": {
    "title": "Kinio 已暂停所有自动处置与远端协助（{{time}} 起）",
    "scope_all": "全部组织都受影响；监控、事故与通知照常。恢复由 Kinio 操作，这里没有恢复钮。",
    "scope_org": "这个组织受影响；监控、事故与通知照常。恢复由 Kinio 操作。"
  },
  "host": {
    "online": "在线",
    "offline": "离线",
    "offline_for": "离线 {{for}}",
    "shutdown": "已关机 · {{time}}",
    "sleep": "睡眠中",
    "away": "不在现场 · {{for}}",
    "updating": "更新中 · {{n}} 分钟",
    "suspended": "已停用（复制）",
    "revoked": "已撤销",
    "unknown": "不知道",
    "unlicensed": "未授权",
    "is_collector": "收集器",
    "critical": "关键主机",
    "critical_hint": "离线或登记的服务停止算紧急（防抖 3 分钟）。",
    "local_paused": "本机已暂停（{{by}} {{time}}）",
    "local_paused_bar": "这台电脑的用户 {{by}} 在 {{time}} 暂停了自动处置与远端协助（只影响这台）；监控照常。",
    "key_hw": "安全芯片",
    "key_sw": "没有硬件保护",
    "metric_cpu": "CPU",
    "metric_mem": "内存",
    "metric_disk": "磁盘",
    "disk_mount": "磁盘 {{mount}}",
    "primary_user": "主要用户 {{name}}",
    "not_found": "找不到这台电脑",
    "not_found_body": "可能已经移除，或你已经没有这个$t(translation:leaf.cur)的权限。",
    "back_list": "回主机清单",
    "tabs": "主机分页",
    "tab_overview": "概况",
    "tab_telemetry": "回报了什么",
    "this_pc": "这台电脑",
    "class_seat": "{{cls}}（授权台数：{{cls}}）",
    "last_seen": "最后回报",
    "collector_scan": "可以扫的网段",
    "collector_none": "还没有指定网段",
    "collector_error": "收集器回报错误：{{code}}",
    "settings_title": "这台的监控设置",
    "expected_offline": "预期离线时段",
    "expected_offline_hint": "时段内没消息不开事故、不算离线；服务器默认没有。",
    "expected_offline_ws": "工作站默认：下班关机、睡眠不算离线，超过 7 天没上线才列一般。另外可以加固定的时段。",
    "expected_offline_none": "没有",
    "save_note": "改这台的设置会写审计。",
    "saved": "已储存。",
    "primary_user_label": "主要用户",
    "primary_user_hint": "用于搜索与显示（远程协助的等待画面也写这个名字）。可选组织成员或直接输入姓名，不收集登录账号。",
    "primary_user_ph": "例如：王小明 · 会计部",
    "primary_user_member": "组织成员"
  },
  "hosts": {
    "tabs": "主机分页",
    "tab_all": "全部",
    "tab_all_n": "全部（{{n}}）",
    "tab_enrolling": "报到中",
    "tab_unlicensed": "未授权",
    "tab_unlicensed_n": "未授权（{{n}}）",
    "filter_state": "状态",
    "state_any": "状态：全部",
    "state_online": "在线",
    "state_offline": "离线",
    "state_expected_offline": "预期离线",
    "state_suspended": "已停用",
    "state_revoked": "已撤销",
    "filter_class": "类别",
    "class_any": "类别：全部",
    "only_issues": "有异常的",
    "unavailable": "读不到主机清单",
    "none": "还没有电脑报到",
    "none_body": "建部署令牌、在电脑安装管理程序后，电脑会出现在这里。",
    "none_filtered": "没有符合的电脑",
    "shown_all": "已显示全部 {{n}} 台",
    "footnote": "数字只在异常时着色；“已关机 / 睡眠中 / 更新中 / 不在现场”是预期离线，不开事故。",
    "col_name": "名称",
    "col_home": "$t(translation:leaf.cur)",
    "col_org_home": "组织 › $t(translation:leaf.cur)",
    "col_class": "类别",
    "col_state": "状态",
    "col_metrics": "CPU · 内存 · 磁盘",
    "col_version": "管理程序版本",
    "col_key": "金钥保护",
    "col_since": "报到时间",
    "col_actions": "动作",
    "enrolling_none": "没有还在报到的令牌",
    "enrolling_none_body": "有效的部署令牌都已用完或还没建；建一把新的，电脑安装时带上它。",
    "unlicensed_none": "没有未授权的电脑",
    "unlicensed_none_body": "授权台数够用。",
    "unlicensed_bar": "{{n}} 台未授权：",
    "unlicensed_body": "只回报在线与基本资讯，不存指标、不发事故、不能远端协助，本机规则也停。授权台数用完后后报到的先是未授权，不会把已在看管的踢掉。",
    "unlicensed_need_admin": "改派或加购授权要由组织拥有者或组织管理员处理。",
    "reason_released": "授权被改派给别台",
    "search": "搜索名称或主要用户",
    "search_none": "没有符合“{{q}}”的电脑"
  },
  "seat": {
    "server": "服务器",
    "workstation": "工作站",
    "summary_title": "授权台数",
    "available_n": "还有 {{n}} 台可用",
    "all_used": "已全部使用",
    "buy": "加购…",
    "need_billing": "购买授权台数要账单权限，请拥有者（{{name}}）处理。",
    "owner_role": "拥有者",
    "reassign_hint": "也可以把已授权的电脑（例如已离职的笔电）改派给这里的电脑。",
    "reassign_btn": "改派授权…",
    "reassign_title": "把授权改派给 {{host}}",
    "reassign_body": "选一席给这台；原本持有那一席的电脑会变成未授权。",
    "pick": "选一席",
    "option_assigned": "{{host}}（{{time}} 起）",
    "option_free": "空的一席",
    "no_seats": "这个类别没有席次。",
    "reassign_warn": "{{host}} 会变成未授权。",
    "reassign_ok": "改派"
  },
  "net": {
    "title": "网络与主机",
    "hosts_n": "{{n}} 台电脑",
    "unavailable": "读不到主机与网络；其他区块照常。",
    "unreadable": "读不到网络设备",
    "unreadable_collector": "读不到网络设备（收集器 {{name}} 离线 {{for}}）",
    "and_more": "，另 {{n}} 台",
    "unreadable_auth": "读不到网络设备（SNMP 验证失败）",
    "unreadable_note": "交换机、AP 都没算进数字",
    "see_collectors": "查看收集器",
    "collector_unnamed": "收集器",
    "row_network_down": "网络设备没有回应（WAN / 交换机 / AP）",
    "row_servers_offline": "服务器离线",
    "row_collectors_offline": "收集器离线",
    "row_devices_offline": "设备离线",
    "row_storage_faults": "录像主机储存异常",
    "row_recording_gaps": "摄像头有录像缺口（24 小时）",
    "n_network_down": "{{n}} 台",
    "n_servers_offline": "{{n}} 台",
    "n_collectors_offline": "{{n}} 台",
    "n_devices_offline": "{{n}} 台",
    "n_storage_faults": "{{n}} 台",
    "n_recording_gaps": "{{n}} 支",
    "n": "{{n}}",
    "n_hosts": "{{n}} 台",
    "others_ok": "其余 {{n}} 项正常",
    "all_ok": "{{n}} 项都正常",
    "hosts_line": "电脑：{{online}} 在线 · {{expected}} 预期离线",
    "todo_title": "设置待办",
    "todo_note": "不是故障，不算进$t(translation:leaf.cur)状态",
    "todo_unlicensed": "未授权的电脑",
    "tabs": "网络与应用分页",
    "tab_devices": "网络设备",
    "tab_devices_n": "网络设备（{{n}}）",
    "tab_probes": "应用探针",
    "tab_probes_n": "应用探针（{{n}}）",
    "tab_collectors": "收集器",
    "tab_collectors_n": "收集器（{{n}}）",
    "no_homes": "目前范围没有看管中的$t(translation:leaf.cur)",
    "no_homes_body": "换个范围，或先启用 IT 监控。",
    "partial_failed": "{{n}} 个$t(translation:leaf.cur)读不到；其他照常。",
    "col_name": "名称",
    "col_addr": "地址",
    "col_method": "读取方式",
    "col_ifs": "接口",
    "col_poe": "PoE",
    "col_temp": "温度",
    "col_collector": "收集器",
    "col_target": "目标",
    "col_kind": "种类",
    "col_last": "最后检查",
    "col_scan": "负责网段",
    "col_applied": "设置套用",
    "method_snmp": "SNMP 只读",
    "method_ping": "只用 ping",
    "ok_snmp": "可以读取",
    "ok_snmp_n": "可以读取 · {{n}} 个接口",
    "ok_ping": "有回应",
    "ok_probe": "正常",
    "bad_snmp": "读取失败（码 {{code}}）",
    "bad_ping": "没有回应",
    "bad_probe": "失败（码 {{code}}）",
    "unassigned": "没有收集器负责",
    "noresult": "还没有结果",
    "ifs_down": "{{n}}（{{down}} 个断线）",
    "ifs_n": "{{n}} 个接口",
    "devices_note": "扫到的 Kinio 设备不列在这里，在“设备”页；接口、PoE、温度要收集器读得到才有。",
    "devices_none": "还没有网络设备",
    "devices_none_body": "先指定一台电脑当收集器并给它网段，再加交换机、路由器、防火墙。",
    "probes_none": "还没有应用探针",
    "probes_none_body": "用 HTTP / TCP / 文件新鲜度探针看服务有没有在跑。",
    "collectors_none": "还没有收集器",
    "collectors_none_body": "收集器是$t(translation:leaf.cur)里一台装了管理程序的电脑，负责读网络设备与跑探针。",
    "setup_collector": "设置收集器",
    "setup_probe": "新增探针",
    "applied_v": "已套用 v{{v}}",
    "pending_v": "待套用 v{{v}}（目前 v{{cur}}）",
    "row_disks_full": "磁盘快满",
    "n_disks_full": "{{n}} 台",
    "by_org_title": "按组织",
    "org_net_down": "网络设备没有响应 {{n}}",
    "org_unreadable": "读不到网络设备",
    "org_servers_offline": "服务器离线 {{n}}",
    "org_disks_full": "磁盘快满 {{n}}",
    "org_collectors_offline": "采集器离线 {{n}}",
    "orgs_others_ok": "其余 {{n}} 个组织正常",
    "orgs_more": "另有 {{n}} 个组织有状况，从主机页筛选组织查看",
    "row_ups_on_battery": "电源 · UPS 电池供电中",
    "n_ups_on_battery": "{{n}} 台",
    "row_ups_unreadable": "电源 · UPS 读不到",
    "n_ups_unreadable": "{{n}} 台",
    "row_poe_over_warn": "PoE 供电超过注意门槛",
    "n_poe_over_warn": "{{n}} 台",
    "todo_ups_no_downstream": "还没登记下游的 UPS",
    "n_ups": "{{n}} 台",
    "org_ups_on_battery": "UPS 电池供电中 {{n}}",
    "org_poe_over_warn": "PoE 超过门槛 {{n}}",
    "tab_ups": "不间断电源（UPS）",
    "tab_ups_n": "不间断电源（UPS）{{n}}"
  },
  "collector": {
    "intro": "收集器是这个$t(translation:leaf.cur)里一台装了管理程序的电脑：读交换机、路由器、防火墙（SNMP 只读或 ping），跑应用探针。账密只存在收集器，云端看不到。",
    "policy_scan": "组织政策允许扫的网段：{{cidrs}}",
    "policy_none": "组织政策还没允许任何网段：请组织管理员在“组织设置 › IT 监控 › 安全政策”设置。",
    "none": "还没有收集器",
    "none_body": "选一台已上线的电脑当收集器。",
    "add_device": "新增网络设备…",
    "need_collector": "要先有收集器才能加网络设备。",
    "kinio_note": "扫到的 Kinio 设备（摄像头、Kinio Station）标“已是 Kinio 设备”并连到设备页，不重复建立。",
    "title": "收集器",
    "scan": "可以扫的网段",
    "scan_hint": "每行一个网段（例 10.20.0.0/16）；要在组织政策允许的范围内。",
    "saved": "已储存，收集器上线时会套用。",
    "err_scan": "{{target}} 不在组织允许扫的网段内。",
    "save_scan": "储存网段",
    "local_note": "收集器本机也要开（管理程序设置）；没开时这里会显示错误。",
    "pick": "选哪台电脑",
    "make": "设成收集器"
  },
  "probe": {
    "intro": "探针由收集器定时检查：HTTP（状态码、关键词、证书到期）、TCP 端口、文件新鲜度（排程有没有跑）。不收回应内容。",
    "add": "新增探针…",
    "add_title": "新增探针",
    "edit": "修改…",
    "edit_title": "修改探针",
    "kind_ping": "ping",
    "kind_snmp": "SNMP",
    "kind_http": "HTTP",
    "kind_tcp": "TCP 端口",
    "kind_file": "文件新鲜度",
    "host": "主机名称或地址",
    "port": "端口",
    "scheme": "协定",
    "path": "路径",
    "keyword": "关键词（选填）",
    "http_hint": "只比对状态码 200 与关键词、量延迟、看证书到期；不跟跳转。",
    "file": "文件路径",
    "file_hint": "只看收集器上这个文件（含网络路径）的最后修改时间，不读内容。",
    "credential": "账密参照",
    "credential_hint": "SNMP 要用收集器上已有的账密参照（账密由管理员在收集器设置，云端看不到）。",
    "interval": "检查间隔",
    "every_s": "每 {{n}} 秒",
    "collector_auto": "自动（依网段）",
    "err_target": "请填目标地址",
    "err_port": "端口要是 1–65535",
    "err_path": "路径要以 / 开头",
    "err_file": "请填文件路径",
    "err_collector_offline": "收集器离线，无法测试；先确认收集器在线。",
    "err_collector_disabled": "收集器本机没开收集功能。",
    "test": "测试连接",
    "test_ok": "可以连上",
    "tls_days": "证书 {{n}} 天后到期",
    "test_timeout": "没有回应（逾时）",
    "test_unreachable": "连不到",
    "test_auth_failed": "验证失败：用户名称或密码不对",
    "test_credential_missing": "没有账密",
    "test_tls_error": "证书有问题",
    "test_dns": "名称解析失败",
    "test_unexpected": "回应不符预期",
    "test_not_allowed": "目标不在允许范围",
    "test_collector_error": "收集器错误",
    "test_failed": "失败",
    "create": "建立",
    "delete": "删除…",
    "delete_title": "删除“{{name}}”",
    "delete_body": "它的检查与事故一起解除。",
    "none_body": "新增一个探针看服务有没有在跑。"
  },
  "threshold": {
    "intro": "每个条件的等级与防抖（连续多久才开事故）；改了只影响这个$t(translation:leaf.cur)。防抖只能比默认长；影响录像的条件不能关。",
    "col_condition": "条件",
    "col_severity": "等级",
    "col_debounce": "防抖",
    "rule_home_unreachable": "$t(translation:leaf.cur)失联",
    "rule_camera_not_recording": "摄像头没有录像",
    "rule_recorder_storage": "录像主机硬盘故障或录像空间 0",
    "rule_critical_host": "关键主机离线或服务停止",
    "rule_network_device": "交换机 / 路由器 / WAN 没有回应",
    "rule_server_offline": "一般服务器离线、服务停止；收集器离线",
    "rule_disk_tls_probe": "磁盘快满、SMART 警告、TLS 到期、探针失败",
    "rule_unreadable": "读不到（收集器或管理程序失联）",
    "rule_enroll_failed": "新电脑报到失败",
    "rule_workstation_offline": "工作站离线超过期限",
    "changed": "已改",
    "immediate": "立即",
    "minutes": "{{n}} 分钟",
    "no_incident": "不开事故",
    "disk_pct": "磁盘快满（%）",
    "tls_days": "TLS 几天内到期",
    "ws_days": "工作站离线几天才列一般",
    "err_disk": "磁盘门槛要在 50–99",
    "err_tls": "TLS 天数要在 1–90",
    "err_ws": "工作站天数要在 7–90",
    "reset": "还原默认",
    "save_note": "改门槛会写审计。",
    "saved": "已储存。",
    "updated": "{{name}} 于 {{time}} 修改"
  },
  "maint": {
    "title": "维护时段",
    "inactive": "现在不是维护中。",
    "set_by": "{{name}} {{time}} 设的",
    "active_note": "维护中不开事故、不推播、不自动处置；影响录像的仍送现场通知。结束后仍异常的 5 分钟后开事故。",
    "end": "结束维护",
    "quick_label": "一键维护",
    "extend_label": "延长",
    "hours_n": "{{n}} 小时",
    "start": "设成维护中 {{n}} 小时",
    "extend": "延长",
    "quick_note": "新设或延长要再确认一次身份，并通知这个$t(translation:leaf.cur)所属组织的拥有者与管理员；结束不用。",
    "schedule": "排程维护",
    "schedule_none": "没有排程。",
    "save_note": "新设或改排程要再确认一次身份并通知客户。",
    "save_schedule": "储存排程",
    "saved": "已储存。",
    "saved_notified": "已储存，已通知 {{n}} 人。",
    "unchanged": "没有变更。"
  },
  "biz": {
    "title": "营业时段",
    "intro": "营业时段外摄像头与工作站的离线降一级（不是不通知）；状态旁加 ☾。",
    "all_day": "全天营业（没设时段）。",
    "save_note": "不用再确认身份；会写审计。",
    "saved": "已储存。"
  },
  "window": {
    "days": "星期",
    "start": "开始",
    "end": "结束",
    "remove": "移除",
    "add": "加一段",
    "hint": "开始与结束一样 = 整天；结束早于开始 = 跨午夜。",
    "err_days": "每段至少选一天",
    "err_time": "时间格式要是 时:分",
    "every_day": "每天",
    "all_day": "整天"
  },
  "site": {
    "title": "现场资讯",
    "intro": "事故页最上面会显示这些；每次修改写审计。",
    "edit": "编辑",
    "collapse": "收合",
    "expand": "展开",
    "customer": "客户",
    "level_n": "服务等级 {{level}}",
    "until": "到 {{date}}",
    "level_note": "服务等级只显示，不影响通知：紧急事故一律照轮值表推播。",
    "contact": "现场联络",
    "call": "拨打",
    "it_support": "IT 支持",
    "rack": "机柜",
    "access": "门禁",
    "f_service_level": "服务等级",
    "f_contract_until": "合约到期",
    "f_contact_role": "联络人身份",
    "f_contact_name": "现场联络人",
    "f_contact_phone": "电话",
    "f_it_support": "IT 支持电话与时段",
    "f_rack_note": "机柜说明",
    "f_access_note": "门禁说明",
    "h_service_level": "只显示在事故页，不影响通知。",
    "h_contact_phone": "事故页可直接拨打。",
    "h_it_support": "员工求助画面会显示。",
    "ph_role": "大楼夜班保全",
    "ph_it": "02-2345-6789 · 周一至周五 08:30–18:00",
    "err_phone": "电话只能有数字、+、-、括号。",
    "save_note": "有“监控设置”权限的人能改；每次修改写审计。",
    "saved": "已储存。",
    "preview": "预览：事故页"
  },
  "telemetry": {
    "intro": "“{{agent}}”只回报下面这些电脑健康资讯给 {{org}}，不看画面、文件与输入。",
    "last_upload": "最近一次回报 {{time}}。",
    "item_cpu_mem_disk": "CPU / 内存 / 磁盘",
    "desc_cpu_mem_disk": "使用率、每个磁盘的用量与 SMART 状态",
    "item_net_bytes": "网卡流量总量",
    "desc_net_bytes": "每个接口的上传 / 下载总量；不收连接目的地",
    "item_uptime_power": "开机时间 · 电源状态",
    "desc_uptime_power": "开机多久、关机 / 睡眠 / 更新重开",
    "item_services": "服务是否在跑",
    "desc_services": "只有管理程序发现并登记的服务名称与状态",
    "item_os_update": "系统更新",
    "desc_os_update": "有没有待安装的更新",
    "item_event_log": "系统事件记录",
    "desc_event_log": "只送符合规则的片段，用户名称、Email 与 IP 已遮罩；默认不收登录名称与安全事件",
    "never_title": "一律不收",
    "never_cmdline": "程序的命令列参数",
    "never_window_title": "窗口标题",
    "never_files": "开启中的文件名称",
    "never_connections": "逐笔网络连接目的地",
    "never_images": "摄像头影像、缩图、快照",
    "local_page": "要看这台实际送出的值：在那台电脑打开“{{agent}}”›〔看收了什么〕。"
  },
  "remote": {
    "screen_person": "屏幕前的人",
    "your_org": "你的组织",
    "list_sep": "、",
    "dialog_title": "远端协助 · {{host}}",
    "tabs": "远端协助分页",
    "tab_requests": "协助请求",
    "tab_requests_n": "协助请求（{{n}}）",
    "tab_records": "记录",
    "form_lead": "{{name}}会在电脑上看到你的名字与「{{org}}」，按〔允许〕才会开始。整段期间对方屏幕有红框与浮动列，可以随时结束。",
    "not_admin": "{{name}}不是这台电脑的管理员：遇到要管理员密码的窗口（例如安装驱动），你看不到也无法代按，需要现场有管理员账号的人。",
    "perms_title": "要对方允许的权限",
    "perm": {
      "view": "看",
      "control": "控制",
      "clipboard": "剪贴板",
      "file_transfer": "文件传输"
    },
    "perm_hint": {
      "view": "看对方的画面（一定有）",
      "control": "用鼠标与键盘操作",
      "clipboard": "跟对方互相复制粘贴文字",
      "file_transfer": "传文件给对方；对方也可以自己挑文件传给你"
    },
    "no_recording": "这次不录影。",
    "no_recording_short": "不录影",
    "reason": "理由（写进记录，对方看不到）",
    "reason_ph": "例如：印表机一直显示离线",
    "reason_assist": "求助码 {{code}}",
    "reason_assist_note": "求助码 {{code}}：{{note}}",
    "form_note": "按下后会请你用 passkey 确认身份，接着开启这台电脑上的远端工具。",
    "start_btn": "用 passkey 确认并发起",
    "passkey_canceled": "passkey 确认取消了，还没有发起。",
    "auth_waiting": "请依浏览器的提示用 passkey 确认身份…",
    "tool_first": "这台电脑第一次用远端协助？",
    "tool_first_body": "对方的画面会在「远端工具」窗口里，先下载安装；已经装好就直接发起。",
    "tool_missing": "没有跳出远端工具？",
    "tool_missing_body": "这台电脑可能还没装。下载安装后回到这一页，会自动再开一次（2 分钟内）；超过时间请取消后再发起一次。",
    "dl": {
      "windows": "下载远端工具（Windows）",
      "macos": "下载远端工具（macOS）",
      "linux": "下载远端工具（Linux）"
    },
    "dl_none": "这个环境没有设置远端工具的下载位置，请找系统管理员。",
    "relaunch": "开启远端工具",
    "tool_installed": "已经装好了",
    "tool_open": "远端工具已开启；对方允许后就会看到画面。",
    "tool_opening": "正在开启远端工具…没反应的话按",
    "waiting": "等待{{name}}允许（{{time}}）",
    "waiting_over": "{{name}}还没有回应，正在确认…",
    "waiting_body": "{{name}}的电脑上跳出允许窗口；只有对方本人能按。可以打电话请对方按〔允许〕。",
    "cancel_session": "取消这次协助",
    "connected": "已连上 {{host}}",
    "connected_body": "对方的画面在远端工具窗口里。{{name}}的屏幕一直有红框与浮动列，随时可以结束或收回权限。",
    "slow": "连线较慢",
    "upgrade_waiting": "等待{{name}}允许{{what}}（{{time}}）",
    "upgrade_input_off": "等待期间你的鼠标与键盘暂停。",
    "extend_what": "延长 {{n}} 分钟",
    "col_perms": "权限",
    "col_until": "时间",
    "until": "到 {{time}} 自动结束（还有 {{n}} 分钟）",
    "col_recording": "录影",
    "tip_uac": "对方画面出现系统权限窗口时你看不到，请对方自己按。",
    "tip_cad": "不能送 Ctrl+Alt+Del（系统安全画面）。",
    "add_title": "要加的权限",
    "add_note": "会在{{name}}的电脑上再跳一次允许窗口；对方没按就维持现在的权限。要先用 passkey 确认身份。",
    "add_send": "用 passkey 确认并送出",
    "add_btn": "加权限…",
    "extend_btn": "延长 {{n}} 分钟",
    "end_btn": "结束协助",
    "ended_title": "{{host}} 的远端协助已结束",
    "ended_by": {
      "operator_end": "你结束了这次协助。",
      "user_end": "{{name}}按了结束。",
      "time_limit": "时间到，自动结束。"
    },
    "col_duration": "时长",
    "col_files": "传过的文件",
    "no_files": "没有传文件",
    "note": "加一句备注（写进记录）",
    "note_ph": "例如：重设印表机队列后恢复",
    "external_ticket": "外部工单（选填）",
    "external_ticket_ph": "例如：SR-20481",
    "note_audit": "备注与工单会写进这次协助的记录，组织管理员看得到。",
    "note_saved": "已写进记录。",
    "note_save_close": "存进记录并关闭",
    "note_then_close": "加备注后结束",
    "note_shown": "备注：{{note}} · 外部工单：{{ticket}}",
    "done": "完成",
    "done_no_note": "不加备注，关闭",
    "close": "关闭",
    "retry": "再试一次",
    "go_passkey": "去注册 passkey",
    "go_policy": "去组织安全政策",
    "go_seats": "去改派授权",
    "err_code": "错误码 {{code}}",
    "dur_lt_min": "不到 1 分钟",
    "dur_h_m": "{{h}} 小时 {{m}} 分钟",
    "out": {
      "denied": "{{name}}拒绝了这次协助",
      "reported": "{{name}}回报没有要求协助",
      "timeout": "{{name}}没有回应",
      "no_user": "这台电脑目前没有人登录，有人值守协助需要屏幕前的人按允许",
      "locked": "{{name}}的屏幕锁定中，请对方先解锁",
      "reported_recently": "这台电脑 24 小时内有人按过「我没有要求协助」",
      "region": "这台电脑在中国大陆，不能远端协助",
      "allowance": "这台电脑的设置不允许远端协助",
      "org_policy": "组织的安全政策没有开远端协助",
      "paused": "远端协助已暂停",
      "global_stop": "Kinio 已暂停所有远端协助",
      "unsupported_desktop": "这台电脑的桌面还不支持远端协助",
      "role": "你没有这台电脑的远端协助权限",
      "forbidden": "你没有这台电脑的远端协助权限",
      "busy": "这台电脑已经有进行中的远端协助",
      "offline": "这台电脑目前离线",
      "unlicensed": "这台电脑未授权，不能远端协助",
      "taken": "这个请求已经有人接手了",
      "assist_expired": "这个协助请求已经过期",
      "need_passkey": "要先有 passkey 才能远端协助",
      "receipt": "身份确认没有通过",
      "too_many": "你同时进行的远端协助太多了",
      "no_answer": "这台电脑没有回应",
      "connect_failed": "{{name}}允许了，但没有接上",
      "connection_lost": "连线中断，协助已结束",
      "expired": "这次发起已经过期",
      "revoked": "你的远端协助权限被收回，协助已结束",
      "kill_switch": "组织停止了远端协助，协助已结束",
      "error": "没有开始",
      "unlock_timeout": "{{name}}一直没有解锁屏幕"
    },
    "out_next": {
      "denied": "可以加一句备注写进记录；需要的话先打电话跟对方确认，再发起一次。",
      "reported": "已通知「{{org}}」的管理员；这台 24 小时内不能再由你发起。",
      "timeout": "60 秒内没有按〔允许〕算拒绝。可以先打电话请对方准备好，再试一次。",
      "no_user": "请对方登录后按系统托盘〔请求远端协助〕，请求会出现在「协助请求」。",
      "locked": "对方解锁后按〔再试一次〕。",
      "reported_recently": "这段期间只能由对方自己在系统托盘按〔请求远端协助〕，再从「协助请求」开始。",
      "region": "在中国大陆的电脑不开远端协助。",
      "allowance": "要由组织所有者或管理员放宽这台电脑的允许范围。",
      "org_policy": "组织所有者或管理员可以在「组织设置 › IT 监控 › 安全政策」打开。",
      "paused": "这台电脑的使用者或组织暂停了自动处置与远端协助；恢复后再试。",
      "global_stop": "监控、事故与通知照常；恢复由 Kinio 操作。",
      "unsupported_desktop": "Linux 目前只支持 X11 桌面。",
      "role": "请组织管理员给你「远端协助（有人在场）」的权限。",
      "forbidden": "请组织管理员给你「远端协助（有人在场）」的权限。",
      "busy": "等那一次结束再发起；如果是你自己的，到「远端协助 › 记录」按〔回到协助〕。",
      "offline": "等它上线再试一次。",
      "unlicensed": "到主机页的「未授权」改派授权后再发起。",
      "taken": "同一个请求只会由一个人协助。",
      "assist_expired": "请求 30 分钟就失效；请对方在系统托盘再请求一次。",
      "need_passkey": "远端协助每次都要用 passkey 确认身份（验证码不算）。到「我的账号 › 安全性」注册。",
      "receipt": "可能是确认逾时或电脑时间不准，请再试一次。",
      "too_many": "同一个人最多同时 3 个，先结束其他的。",
      "no_answer": "可能刚好断线，稍后再试一次。",
      "connect_failed": "远端工具 60 秒内没有连上。确认远端工具已开启后再试一次。",
      "connection_lost": "对方电脑断线超过 30 秒。可以再试一次。",
      "expired": "建立后 5 分钟内没有完成身份确认，请再试一次。",
      "revoked": "",
      "kill_switch": "",
      "error": "请再试一次。",
      "unlock_timeout": "请对方解锁后按〔再试一次〕，或请对方按系统托盘〔请求远端协助〕。"
    },
    "state": {
      "requested": "准备中",
      "awaiting_consent": "等待对方允许",
      "active": "进行中",
      "upgrade_pending": "进行中（等待加权限）"
    },
    "end": {
      "denied": "对方拒绝",
      "reported": "对方回报没有要求协助",
      "timeout": "对方没有回应",
      "operator_end": "已结束",
      "user_end": "对方结束",
      "revoked": "权限收回",
      "time_limit": "时间到",
      "kill_switch": "组织停止",
      "rejected": "没有开始（这台当时不能远端协助）",
      "expired": "没有完成身份确认",
      "connect_failed": "没有接上",
      "connection_lost": "连线中断",
      "unknown": "已结束"
    },
    "unreadable": "读不到主机清单",
    "no_hosts": "范围内还没有电脑",
    "no_hosts_body": "电脑报到后就可以在这里协助。",
    "forbidden": "你没有远端协助的权限",
    "forbidden_body": "要有「远端协助（有人在场）」的权限才看得到协助请求；「记录」分页看得到你自己发起的协助。请找组织管理员。",
    "assist_partial": "{{n}} 个组织的协助请求读不到",
    "assist_title": "{{who}} 请求协助",
    "assist_code": "求助码 {{code}}",
    "assist_age": "{{time}} 送出",
    "assist_left": "{{n}} 分钟后失效",
    "assist_taken": "{{name}}已接手",
    "assist_start": "开始协助",
    "assist_note": "请在电话里跟对方核对求助码，确认是同一台电脑；开始后对方仍要按〔允许〕。",
    "assist_none": "目前没有协助请求",
    "assist_none_body": "员工在电脑的系统托盘按〔请求远端协助〕，这里就会出现；有权限的人也会收到通知。",
    "other_member": "其他成员",
    "range_from": "从",
    "range_to": "到",
    "export_csv": "导出 CSV",
    "csv": {
      "start": "开始",
      "end": "结束",
      "minutes": "时长（分钟）",
      "operator": "操作者",
      "org": "组织",
      "home": "$t(translation:leaf.cur)",
      "host": "主机",
      "permissions": "权限",
      "result": "结果",
      "reason": "理由",
      "note": "备注",
      "external_ticket": "外部工单"
    },
    "records_unreadable": "读不到远端协助记录",
    "col_start": "开始",
    "col_host": "主机",
    "col_operator": "操作者",
    "col_result": "结果",
    "col_note": "备注 / 外部工单",
    "resume": "回到协助",
    "resume_host": "回到远端协助",
    "ticket_short": "工单 {{ticket}}",
    "records_note": "时长从对方按〔允许〕算到结束；远端协助一律不录影。",
    "records_none": "这段期间没有远端协助",
    "records_none_body": "换一段期间看看。",
    "host_btn": "远端协助",
    "block": {
      "unlicensed": "未授权的电脑不能远端协助",
      "inactive": "这台已停用",
      "offline": "这台目前离线",
      "region": "在中国大陆，不能远端协助",
      "allowance": "这台的设置不允许远端协助",
      "local_paused": "使用者在这台暂停了远端协助",
      "phone": "请在电脑上开始远端协助"
    },
    "wait_unlock": "{{name}}的屏幕锁定中",
    "wait_unlock_body": "对方解锁后会自动再弹出允许窗口，不用重新发起；最晚等到 {{time}}。可以打电话请对方先解锁。",
    "sent_to_console": "这台电脑还有 {{n}} 个其他登录的会话；允许窗口发送到屏幕前（控制台）的{{name}}。",
    "records_access_partial": "有些$t(translation:leaf.cur)你只看得到自己发起的记录（没有那些$t(translation:leaf.cur)的远端协助权限，也不是组织拥有者或管理员）。",
    "records_access_own": "只显示你自己发起的记录：你没有这个范围的远端协助权限，也不是组织拥有者或管理员。"
  },
  "review": {
    "go": "看待确认的电脑",
    "title": "等你确认（{{n}}）",
    "intro": "主机名不在预期清单、或跟已报到的电脑同名的电脑先停在这里：你接受前不会拿到身份，也不占令牌台数与席位。它们每 15 分钟会再送一次报到。",
    "selected": "已选 {{n}} 台",
    "select_hint": "勾选后可以一起处理",
    "select_all": "全选待确认的电脑",
    "select_one": "选 {{host}}",
    "reject_btn": "拒绝…",
    "accept_btn": "接受…",
    "col_reason": "为什么要确认",
    "col_seen": "出现时间",
    "col_actions": "处理",
    "no_hostname": "（没有回报主机名）",
    "reason_not_listed": "不在预期清单",
    "reason_duplicate_name": "跟已报到的电脑同名",
    "first": "第一次 {{time}}",
    "last": "最后一次 {{time}}",
    "inactive": "这把令牌已经不能用了，这些电脑不能再接受；要加入请建新令牌。",
    "none_pending": "没有等你确认的电脑。",
    "done_title": "已处理（{{n}}）",
    "state_pending": "待确认",
    "state_accepted": "已接受",
    "state_rejected": "已拒绝",
    "state_expired": "令牌失效，未处理",
    "accept_title": "接受 {{n}} 台电脑",
    "accept_body": "{{list}}：接受后会拿到身份、绑进这把令牌的$t(translation:leaf.cur)、用掉 {{n}} 台令牌额度与席位（没有空席时先是未授权）· 约 15 分钟内完成报到。接受前会再确认一次你的身份。",
    "accept": "接受",
    "reject_title": "拒绝 {{n}} 台电脑",
    "reject_body": "{{list}}：之后用这把令牌报到都会被拒（改主机名也一样）；要再加入请重建令牌。",
    "reject": "拒绝",
    "partial": "处理了 {{ok}} 台；这些没处理：{{bad}}",
    "accepted_n": "已接受 {{n}} 台，约 15 分钟内会完成报到。",
    "rejected_n": "已拒绝 {{n}} 台。",
    "err_done": "已经处理过或不在这把令牌"
  },
  "tpl": {
    "intro": "把阈值、探针、自动处置规则、通知与维护 / 营业时段存成模板，一次套用到多个$t(translation:leaf.cur)。模板出新版不会自动下发，要再套用。",
    "show_archived": "显示已归档",
    "new": "新建模板",
    "new_title": "新建监控模板",
    "empty_title": "还没有监控模板",
    "empty_body": "建一份模板，之后在“套用”选$t(translation:leaf.cur)、看差异再套用。",
    "col_name": "名称",
    "col_items": "内容",
    "col_version": "版本",
    "col_updated": "最后修改",
    "col_started": "开始时间",
    "col_state": "状态",
    "col_result": "结果",
    "col_home": "$t(translation:leaf.cur)",
    "archived": "已归档",
    "archived_note": "这份模板已归档：不能再套用，套用过的$t(translation:leaf.cur)照旧显示来源。",
    "new_hosts_note": "新加入的电脑不会自动补上模板的探针与规则，要再套用一次。",
    "unavailable": "读不到监控模板",
    "applied_homes": "已套用 {{n}} 个$t(translation:leaf.cur)",
    "tabs": "模板分页",
    "tab_content": "内容",
    "tab_apply": "套用",
    "tab_jobs": "套用记录",
    "item_severity_overrides": "阈值与等级",
    "item_maintenance": "维护时段",
    "item_business_hours": "营业时段",
    "item_notify": "通知",
    "item_probes": "探针",
    "item_auto_rules": "自动处置规则",
    "item_hint_severity_overrides": "勾选 = 模板管理全部条件与数字（没改的按默认）。",
    "item_hint_maintenance": "每周重复的维护时段；一次性的维护不进模板。",
    "item_hint_business_hours": "营业时段外，摄像头与工作站的离线降一级。",
    "item_hint_notify": "只带值班表；客户联系人属于客户，模板不会改。",
    "item_hint_probes": "以“对象类别”描述，套用时对应各$t(translation:leaf.cur)已有的主机、网络设备或采集器；不能写固定 IP。",
    "item_hint_auto_rules": "套用到别的组织的$t(translation:leaf.cur)时，规则要客户的拥有者 / 管理员用 passkey 签名才会生效。",
    "item_off": "模板不管这一项（$t(translation:leaf.cur)按自己的设置）。",
    "name": "名称",
    "description": "说明（选填）",
    "not_included": "模板不含账号密码、部署令牌、允许范围策略与客户联系人。",
    "pick_schedule": "选一份值班表",
    "notify_hint": "要是本组织的值班表；套用到客户$t(translation:leaf.cur)后，事故会发给这份值班表的值班人员。",
    "probe_name": "名称",
    "key": "代号",
    "probe_match": "对象",
    "probe_kind": "检查",
    "match_servers": "服务器",
    "match_critical": "关键主机",
    "match_workstations": "工作站",
    "match_all_hosts": "全部主机",
    "match_network_devices": "全部网络设备（已有 SNMP 的）",
    "match_collector_self": "采集器本机",
    "kind_ping": "Ping",
    "kind_tcp": "TCP 端口",
    "kind_http": "HTTP(S)",
    "kind_file": "文件新鲜度",
    "port": "端口",
    "http_path": "路径",
    "file_path": "文件路径",
    "interval": "多久检查一次",
    "seconds": "{{n}} 秒",
    "add_probe": "加一条探针",
    "probe_note": "代号是模板内的稳定标识，改版时同一个代号视为同一条。",
    "rule_service": "服务名称",
    "rule_hosts": "主机",
    "rule_checks": "连续几次失败",
    "add_rule": "加一条规则",
    "rule_note": "服务停了自动重启一次；对应超过 3 台的$t(translation:leaf.cur)不建（改由人处理）。",
    "err_name": "要填名称",
    "err_empty": "至少要有一项",
    "err_maint_empty": "维护时段至少一段",
    "err_schedule": "要选值班表",
    "err_key": "代号只能用小写英文数字、_ 或 -",
    "err_key_dup": "代号重复",
    "err_port": "TCP 要填端口",
    "err_http_path": "HTTP 路径要以 / 开头",
    "err_file": "文件新鲜度只能检查采集器本机，要填路径",
    "err_service": "要填服务名称",
    "save": "保存",
    "create": "建立模板",
    "save_note": "内容改了会变成新版本；已套用的$t(translation:leaf.cur)不会自动更新。",
    "saved": "已保存。",
    "saved_version": "已存成 v{{v}}。要套用到$t(translation:leaf.cur)请到“套用”。",
    "conflict": "别人刚改过这份模板，请刷新后再改。",
    "archive": "归档",
    "archive_confirm": "归档后不能再套用；套用过的$t(translation:leaf.cur)不受影响。确定归档？",
    "pick_intro": "选要套用 v{{v}} 的$t(translation:leaf.cur)（你要对每个$t(translation:leaf.cur)有“设置”权限，经委派也可以），下一步先看差异。",
    "pick_filter": "搜索$t(translation:leaf.cur)",
    "pick_all": "全选（{{n}}）",
    "pick_none": "清除",
    "picked": "已选 {{n}} 个$t(translation:leaf.cur)",
    "preview_note": "预览不会改任何设置；200 个$t(translation:leaf.cur)一批。",
    "preview": "预览差异（{{n}}）",
    "diff_summary": "{{homes}} 个$t(translation:leaf.cur)、{{changes}} 项会变；涉及 {{orgs}} 个客户组织，套用后各收到 1 条通知。",
    "show_same": "显示没变的项目",
    "pending_rules": "{{n}} 条自动处置规则会等“{{org}}”用 passkey 签名，签名前不会执行。",
    "n_homes": "{{n}} 个$t(translation:leaf.cur)",
    "n_changes": "{{n}} 项会变",
    "customer_field": "客户的设置（{{v}}），模板不会改",
    "skip_no_target": "这个$t(translation:leaf.cur)没有对应得到的对象，这条不建",
    "skip_too_many_targets": "对应超过 3 台，这条不自动建（请人处理）",
    "ov_by": "{{org}}改的（{{name}} {{date}}）",
    "fate_keep": "默认保留",
    "fate_overwrite": "会被覆盖",
    "overwrite_anyway": "仍要覆盖",
    "pending_rule_row": "套用后待客户签名",
    "skipped_title": "跳过 {{n}} 个$t(translation:leaf.cur)",
    "reason_no_permission": "你对这个$t(translation:leaf.cur)没有设置权限",
    "reason_not_enabled": "这个$t(translation:leaf.cur)还没启用 IT 监控",
    "reason_no_target": "模板的探针与规则在这个$t(translation:leaf.cur)都对应不到对象",
    "reason_cancelled": "已中断，没有套用",
    "reason_error": "暂时套用不上（已重试 3 次）",
    "reason_feature_disabled": "这个环境没开自动处置",
    "reason_rule": "自动处置规则写不进去（{{detail}}）",
    "back_pick": "重新选$t(translation:leaf.cur)",
    "apply_note": "套用会改到客户$t(translation:leaf.cur)的设置，要重新验证身份。",
    "apply": "套用到 {{n}} 个$t(translation:leaf.cur)",
    "apply_confirm": "确定套用到 {{n}} 个$t(translation:leaf.cur)？会通知 {{orgs}} 个客户组织；客户改过的项目按上面的勾选处理。",
    "apply_ok": "确定套用",
    "preview_expired": "预览已过期（10 分钟），请重新预览。",
    "jobs_empty": "还没套用过",
    "job_queued": "排队中",
    "job_running": "套用中",
    "job_done": "已完成",
    "job_cancelled": "已中断",
    "job_counts": "已套用 {{applied}}、跳过 {{skipped}}、失败 {{failed}}（共 {{total}}）",
    "job_progress": "{{done}} / {{total}}",
    "cancelling": "中断中：跑完当前这一户就停",
    "notified": "已通知 {{n}} 个客户组织",
    "cancel": "中断",
    "retry": "重试失败的 {{n}} 个$t(translation:leaf.cur)",
    "result_pending": "等待中",
    "result_applied": "已套用",
    "result_skipped": "跳过",
    "result_failed": "失败",
    "home_result": "改了 {{changed}} 项、保留 {{kept}} 项",
    "home_pending": "{{n}} 条规则待客户签名",
    "changed_since_preview": "预览后客户又改过，已按当下重算",
    "num_disk_pct": "磁盘快满",
    "num_tls_days": "TLS 到期天数",
    "num_workstation_offline_days": "工作站离线天数",
    "key_schedule": "值班表",
    "key_customer_contact": "客户联系人",
    "v_none": "没有",
    "v_owner_default": "$t(translation:leaf.cur)拥有者（默认）",
    "v_days": "{{n}} 天",
    "v_collector_local": "采集器本机",
    "v_probes": "{{n}} 条（{{targets}}）",
    "v_rule": "{{service}} 停了重启 · 连续 {{checks}} 次 · {{n}} 台",
    "home_using": "沿用“{{org}}”的监控模板“{{name}}”v{{v}}",
    "home_overrides": "{{n}} 项在这里改过",
    "home_archived": "“{{name}}”已归档",
    "home_newer": "“{{name}}”有新版 v{{v}}",
    "show_diff": "看差异",
    "hide_diff": "收起",
    "apply_to_others": "应用到其他$t(translation:leaf.cur)…",
    "from_home_name": "{{home}}的设置",
    "from_home_title": "用“{{home}}”当前的设置建模板",
    "from_home_note": "已带入“{{home}}”当前的阈值与等级、维护时段、营业时段与通知值班表。探针与自动处置是这个$t(translation:leaf.cur)自己的对象，需要的话用对象类别在下面添加。保存后直接选择要应用的$t(translation:leaf.cur)。",
    "from_home_skip_notify": "通知用的值班表不属于这个组织，没有带入。",
    "from_home_failed": "读不到这个$t(translation:leaf.cur)当前的设置，请自行勾选要管理的项目。",
    "pick_from_home": "设置来源“{{home}}”不在列表里。",
    "item_power": "用电提醒（PoE 供电门槛）",
    "power_warn": "注意",
    "power_high": "异常",
    "power_hint": "PoE 已配置或实耗占 Station / 交换机额定的比例（50–100%）。套用后写进各$t(translation:leaf.cur)的用电设置，那里标「由模板管理」。",
    "power_err": "门槛要在 50–100，注意不能高于异常",
    "val_power": "PoE 注意 {{warn}}% · 异常 {{high}}%",
    "item_hint_power": "PoE 已配置或实耗占 Station / 交换机额定的比例（50–100%）。套用后写进各$t(translation:leaf.cur)的用电设置，那里标「由模板管理」。"
  },
  "install": {
    "title": "安装参数",
    "tab_windows": "Windows",
    "tab_gpo": "GPO 启动脚本",
    "tab_intune": "Intune",
    "tab_linux": "Linux",
    "tab_rmm": "RMM",
    "note_windows": "以系统管理员运行；静默安装后会自动报到。",
    "note_gpo": "计算机配置 › Windows 设置 › 脚本 › 启动。把脚本与安装文件放在只有域计算机账户读得到的共享文件夹：域用户读得到，等于把令牌交给所有域用户；建议改用 Intune。",
    "note_intune": "Win32 应用的安装命令；安装行为选“系统”。令牌只有 Intune 管理员看得到。",
    "note_linux": "安装软件包后运行；令牌从标准输入读，不留在命令行。",
    "note_rmm": "RMM 工具的安装变量（放在只有管理员看得到的机密字段）。",
    "gpo_download": "下载 GPO 启动脚本"
  },
  "built": {
    "new_title": "替客户建立组织",
    "new_body": "代建的组织由你暂时担任拥有者，先把$t(translation:leaf.cur)、轮值表、模板与令牌设好，再邀请客户接手；不算进你自己最多 5 个组织。“{{org}}”还没完成接手的代建组织最多 20 个。",
    "name": "客户的组织名称",
    "create": "替客户建立",
    "switched": "已切到“{{name}}”",
    "limit": "还没完成接手的代建组织最多 {{n}} 个：先让客户完成接手再建新的。",
    "unavailable": "读不到代建的客户",
    "none": "还没有代建中的客户",
    "none_body": "完成接手的组织不会列在这里，之后的关系看委托。",
    "count": "代建中 {{n}} / {{max}} 个",
    "col_name": "组织",
    "col_builder": "代建者",
    "col_customer": "接手客户",
    "col_created": "建立",
    "customer_owner": "{{name}}（已交出拥有权）",
    "customer_joined": "{{name}}（已加入）",
    "customer_invited": "已邀请 {{email}}",
    "customer_none": "还没邀请"
  },
  "handover": {
    "title": "接手",
    "partner_fallback": "安装商",
    "builder_fallback": "代建者",
    "customer_fallback": "接手客户",
    "not_built": "这个组织没有待接手的事",
    "not_built_body": "不是代建的组织，或已经完成接手。",
    "unavailable": "读不到接手进度",
    "intro_customer": "“{{partner}}”替你建立了“{{org}}”，按下面的顺序完成接手",
    "intro_builder": "你在替客户代建“{{org}}”，按下面的顺序把组织交给客户",
    "remaining": "还差 {{n}} 步",
    "dpa_bar": "客户还没接受数据处理协议，电脑装好也不会开始回报（每 15 分钟自动重试，不用重装）。",
    "dpa_builder": "数据处理协议要由客户接受：你可以先做其他步骤。客户接受前，电脑装好也不会开始回报。",
    "empty_keyset": "目前没有人能放宽这个组织电脑的设置：请在任一台电脑由本机管理员确认，或建新令牌重新安装。",
    "invite_title": "邀请客户",
    "invite_body": "客户用同一个品牌的账号加入后，就能按这一页接手；还没有账号的人会收到注册链接。",
    "invite_email": "客户的电子邮件",
    "invite_btn": "邀请客户",
    "invite_again": "改发给这个地址",
    "invite_pending": "已邀请 {{email}}（{{until}} 前有效）",
    "invited": "已邀请 {{email}}",
    "step_owner": "把拥有权交给“{{customer}}”",
    "step_dpa": "接受数据处理协议",
    "step_delegation": "委托给“{{partner}}”",
    "step_template": "监控模板",
    "step_customer_key": "把“{{customer}}”的密钥加进电脑的管理员清单",
    "step_builder_key": "移除“{{builder}}”的密钥",
    "step_builder_left": "“{{builder}}”完成接手并退出",
    "state_done": "完成",
    "state_skipped": "略过",
    "state_todo": "现在这一步",
    "state_waiting": "等前面的步骤",
    "why_owner": "交出后“{{builder}}”改为组织管理员，直到退出。",
    "why_dpa": "只有客户能接受；接受后电脑才开始回报。",
    "why_delegation": "建议范围“查看 + 设置与单次处置”、12 个月；略过的话，接手后“{{partner}}”看不到、也不能帮你处理。",
    "why_template": "代建期间套用的模板：保留，或改回默认（删掉模板带进来的探针与还没执行过的规则）。",
    "why_customer_key": "加了之后，你才能放宽电脑的设置；由“{{builder}}”用他的密钥签。",
    "why_builder_key": "移除后“{{builder}}”建的令牌会失效，之后由“{{partner}}”经委托重建。",
    "why_builder_left": "退出后代建关系结束，之后只看委托。",
    "wait_builder": "等“{{builder}}”",
    "wait_customer": "等“{{customer}}”",
    "owner_btn": "把拥有权交给“{{customer}}”",
    "owner_need_customer": "先邀请客户加入",
    "owner_confirm_title": "把“{{org}}”的拥有权交给“{{customer}}”",
    "owner_confirm_body": "交出后你改为组织管理员；接下来由“{{customer}}”接受数据处理协议。",
    "dpa_btn": "看协议并接受",
    "deleg_btn": "委托给“{{partner}}”…",
    "skip_btn": "略过",
    "skip_title": "略过委托",
    "skip_body": "略过的话，接手后“{{partner}}”看不到、也不能帮你处理；之后随时可以在“外部组织”委托。",
    "tpl_keep": "保留",
    "tpl_row": "{{home}}：{{name}} v{{v}}",
    "revert_btn": "改回默认",
    "revert_title": "改回默认",
    "revert_body": "{{n}} 个$t(translation:leaf.cur)的模板项目会拿掉：模板带进来的探针与还没执行过的规则删除，门槛与通知保留目前的值。",
    "sign_btn": "签“新增“{{customer}}”的公钥”",
    "no_candidate": "“{{customer}}”还没注册签名通行密钥，请他先注册。",
    "request_body": "请先在“管理员通行密钥”注册你的签名通行密钥，再请“{{builder}}”把它加进电脑的管理员清单。",
    "request_btn": "请“{{builder}}”加入你的密钥",
    "request_sent_at": "{{time}} 已通知“{{builder}}”",
    "register_key": "注册我的签名通行密钥",
    "sign_sent": "已通知“{{builder}}”",
    "sign_wait": "刚通知过，{{time}} 之后可以再通知一次",
    "remove_btn": "移除我的密钥",
    "remove_confirm_title": "移除你的密钥",
    "remove_confirm_body": "你建的 {{n}} 个令牌会失效；失效后由“{{partner}}”经委托重建，新令牌不经过你。已报到的电脑不受影响。",
    "tokens_title": "“{{builder}}”建的令牌（{{n}} 个）会失效",
    "token_row": "{{name}} · 到 {{until}} · 还有 {{n}} 台没报到",
    "tokens_note": "失效后由“{{partner}}”经委托重建，新令牌不经过你；你不用把令牌传给任何人。",
    "tokens_ack": "知道了",
    "revoke_btn": "现在撤销",
    "revoke_title": "撤销 {{n}} 个令牌",
    "revoke_body": "还没报到的电脑会报到失败，要等“{{partner}}”重建令牌、换掉安装设置。",
    "leave_btn": "完成接手并退出",
    "leave_title": "退出“{{org}}”",
    "leave_body": "退出后你在“{{org}}”的权限全部收回，你建的其余令牌撤销；之后“{{partner}}”只能经委托处理。",
    "incomplete_owner_not_transferred": "还没把拥有权交给接手客户。",
    "incomplete_customer_key_missing": "“{{customer}}”的密钥还没加进电脑的管理员清单。",
    "incomplete_builder_key_present": "你的密钥还在电脑的管理员清单上，先移除。",
    "conflict_handover_invite_exists": "已经邀请了接手客户；要换人请先撤回邀请或移出那位成员。",
    "conflict_not_built_org": "这个组织不是代建中的组织。",
    "conflict_already_added": "你的密钥已经在清单上。",
    "conflict_no_candidate": "你还没注册签名通行密钥，先到“管理员通行密钥”注册。",
    "not_handover_customer": "代建的组织只能把拥有权交给接手客户。",
    "banner_customer": "“{{partner}}”替你建立了这个组织",
    "banner_builder": "你在替客户代建“{{org}}”",
    "banner_steps": "，还差 {{n}} 步完成接手",
    "banner_continue": "继续"
  },
  "market": {
    "title": "目前未在您的地区提供",
    "agent_body": "根据您当前连接的地区，{{agent}}暂不提供下载与安装。",
    "tool_body": "根据您当前连接的地区，远程工具暂不提供下载。"
  },
  "power": {
    "phase_outage": "停电中（电池供电）",
    "phase_waiting": "市电已恢复，还有 {{n}} 台没回来",
    "phase_restored": "已恢复",
    "runtime_big": "剩约 {{n}} 分钟",
    "runtime_unk": "剩余时间读不到",
    "runout": "约 {{time}} 用完",
    "battery_pct": "电量 {{pct}}%",
    "load_pct": "负载 {{pct}}%",
    "chart_title": "电池电量 · {{time}} 起",
    "chart_none": "最近 30 分钟的电量读不到",
    "show_numbers": "看数字",
    "col_time": "时间",
    "downstream_line": "接在这台 UPS 后面：{{n}} 台（已离线 {{off}} 台）",
    "downstream_line_ok": "接在这台 UPS 后面：{{n}} 台",
    "no_downstream": "不知道哪些设备接在 UPS 后面",
    "no_downstream_rec": "录像：不知道录像设备有没有接在 UPS 后面",
    "register": "登记下游",
    "offline_title": "还没回来的设备",
    "skip": "不用等这台",
    "skip_aria": "不用等这台：{{name}}",
    "skip_done": "已不再等 {{name}}",
    "escalate_note": "市电恢复 30 分钟后还有没回来的，会按轮值表升级",
    "events_title": "转电池记录",
    "event_line": "{{from}}–{{to}}（{{min}} 分钟）",
    "event_ongoing": "{{from}} 起，还在用电池",
    "escalated": "升级过",
    "live_15": "UPS 剩不到 15 分钟",
    "live_5": "UPS 剩不到 5 分钟",
    "impact_title": "停电影响",
    "row_line": "UPS 剩约 {{n}} 分钟（负载 {{load}}%）",
    "row_line_noload": "UPS 剩约 {{n}} 分钟",
    "row_line_unk": "UPS 剩余时间读不到",
    "col_name": "名称",
    "col_state": "状态",
    "col_battery": "电量",
    "col_runtime": "剩余时间",
    "col_load": "负载",
    "col_downstream": "下游",
    "st_normal": "市电",
    "st_battery": "电池供电 {{n}} 分钟",
    "st_bypass": "旁路",
    "st_none": "输出已断",
    "st_other": "其他",
    "st_selftest": "自检中",
    "st_unreadable": "读不到（最后 {{time}}）",
    "val_unk": "读不到",
    "minutes": "{{n}} 分钟",
    "downstream_n": "{{n}} 台",
    "downstream_none": "还没登记",
    "todo_hint": "还没登记哪些设备接在这台 UPS 后面：停电时它们会各自开事故",
    "empty": "这个范围还没有 UPS。采集器用 SNMP 读到 UPS-MIB 或 APC 的 UPS 会自动出现在这里。",
    "load_err": "读不到 UPS",
    "detail_back": "回 UPS 列表",
    "metrics": "读数",
    "input_v": "输入电压",
    "output_w": "输出功率",
    "temp": "电池温度",
    "test": "自检",
    "test_pass": "通过",
    "test_warning": "有警告",
    "test_error": "失败",
    "test_aborted": "中止",
    "test_in_progress": "进行中",
    "test_none": "没有记录",
    "alarms": "UPS 回报的状况",
    "alarms_none": "没有",
    "downstream_title": "接在这台 UPS 后面",
    "outage_open": "停电事故进行中",
    "see_incident": "看事故",
    "dlg_title": "登记接在「{{name}}」后面的设备",
    "dlg_hint": "停电时这些设备的离线会并进同一件停电事故，不会各自开事故。录像设备（NVR / Station）登记在下游，停电事故才写得出录像影响。",
    "dlg_kinio": "Kinio 设备",
    "dlg_hosts": "主机",
    "dlg_net": "网络设备",
    "dlg_search": "找设备",
    "dlg_all_group": "全选「{{group}}」",
    "dlg_save": "保存（{{n}} 台）",
    "dlg_saved": "已登记 {{n}} 台",
    "dlg_max": "最多 200 个",
    "dlg_cancel": "取消",
    "dlg_none": "这个$t(translation:leaf.cur)没有可以登记的设备",
    "no_configure": "你没有这个$t(translation:leaf.cur)的监控设置权限",
    "alarm": {
      "battery_bad": "需要更换电池",
      "on_battery": "电池供电中",
      "low_battery": "电量低",
      "depleted_battery": "电池耗尽",
      "temp_bad": "温度异常",
      "input_bad": "市电输入异常",
      "output_bad": "输出异常",
      "output_overload": "输出过载",
      "on_bypass": "旁路中",
      "bypass_bad": "旁路异常",
      "output_off_as_requested": "输出已按指令关闭",
      "ups_off_as_requested": "UPS 已按指令关闭",
      "charger_failed": "充电器故障",
      "ups_output_off": "输出已断",
      "ups_system_off": "UPS 已关机",
      "fan_failure": "风扇故障",
      "fuse_failure": "保险丝故障",
      "general_fault": "一般故障",
      "diagnostic_test_failed": "自检失败",
      "communications_lost": "UPS 通信中断",
      "awaiting_power": "等待市电恢复",
      "shutdown_pending": "即将关机",
      "shutdown_imminent": "马上关机",
      "test_in_progress": "自检中"
    }
  }
}
